import { useAuth } from "context/AuthProvider";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  UncontrolledAlert,
} from "reactstrap";
import { apiCentrosService } from "services/apiCentrosService";

const AddCentro = () => {
  const { empresa } = useAuth();
  const navigate = useNavigate();
  const [nombre, setNombre] = useState();
  const [direccion, setDireccion] = useState();
  const [comentarios, setComentarios] = useState();

  const [status, setStatus] = useState("pending");

  const handleChange = (e) => {
    setNombre(e.target.value);
  };

  const handleClear = (e) => {
    e.preventDefault();
    setNombre("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const json = {
      nombre: nombre,
      empresa: { id: empresa.id },
    };
    const response = await apiCentrosService.create(json);

    setStatus(response.status);
    // Limpiar el estado después de 3 segundos
    setTimeout(() => {
      setStatus("pending");
    }, 3000);
    if (response.status === "saved") {
      handleClear(e);
    }
  };

  const lg = 12;
  return (
    <>
      <Card>
        <CardHeader>Dar de alta centro:</CardHeader>
        <CardBody>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col lg={lg}>
                <FormGroup>
                  <Label htmlFor="nombre" className="form-control-label">
                    Nombre:
                  </Label>
                  <Input
                    type="text"
                    name="nombre"
                    className="form-control-alternative"
                    value={nombre}
                    onChange={handleChange}
                    required
                  ></Input>
                </FormGroup>
              </Col>
              <Col lg={12}>
                <FormGroup>
                  <Label htmlFor="direccion" className="form-control-label">
                    Dirección:
                  </Label>
                  <Input
                    type="text"
                    name="direccion"
                    className="form-control-alternative"
                    value={direccion}
                    onChange={(e) => setDireccion(e.target.value)}
           
                  ></Input>
                </FormGroup>
              </Col>
              <Col lg={12}>
                <FormGroup>
                  <Label htmlFor="comentarios" className="form-control-label">
                    Comentarios:
                  </Label>
                  <Input
                    type="textarea"
                    name="comentarios"
                    className="form-control-alternative"
                    value={comentarios}
                    onChange={(e) => setComentarios(e.target.value)}
              
                  ></Input>
                </FormGroup>
              </Col>
            </Row>
            <div className="text-right">
              <Button className="btn btn-success" type="submit">
                Guardar
              </Button>
              <Button className="btn btn-secondary" onClick={() => navigate("/admin/centros")}>
                Volver
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
      <div className="mt-3">
        {status === "saved" ? (
          <UncontrolledAlert color="success" fade={true}>
            <span className="alert-inner--icon">
              <i className="ni ni-like-2" />
            </span>{" "}
            <span className="alert-inner--text">
              <strong>¡Guardado!</strong> Se ha guardado correctamente
            </span>
          </UncontrolledAlert>
        ) : (
          ""
        )}
        {status === "duplicated" ? (
          <UncontrolledAlert color="warning" fade={true}>
            <span className="alert-inner--icon">
              <i className="ni ni-fat-remove" />
            </span>{" "}
            <span className="alert-inner--text">
              <strong>¡Duplicado!</strong> Este centro ya existe.
            </span>
          </UncontrolledAlert>
        ) : (
          ""
        )}

        {status === "error" ? (
          <UncontrolledAlert color="danger" fade={true}>
            <span className="alert-inner--icon">
              <i className="ni ni-fat-remove" />
            </span>{" "}
            <span className="alert-inner--text">
              <strong>¡Error!</strong> Se ha producido un error.
            </span>
          </UncontrolledAlert>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default AddCentro;

